import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MenuIconService {
  private currentIcon = signal<string>('Folder');

  getIcon() {
    return this.currentIcon;
  }

  setIcon(icon: string) {
    this.currentIcon.set(icon);
  }
}
